const FamilyTicketIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    fill="none"
    viewBox="0 0 20 21"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.125 11.587a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M18.75 18.462a3.125 3.125 0 0 0-5-2.5M1.875 11.587a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M1.25 18.462a3.126 3.126 0 0 1 5-2.5M8.125 14.712a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0M10 17.837a3.12 3.12 0 0 0-2.864 1.875M10 17.837a3.13 3.13 0 0 1 2.88 1.908M15.584 2.178V.917A.417.417 0 0 0 15.167.5H5.255a.417.417 0 0 0-.417.417v.895a.41.41 0 0 0 .318.4 1.5 1.5 0 0 1-.318 2.972v1.263a.417.417 0 0 0 .417.416h9.912a.417.417 0 0 0 .417-.416V5.184a1.503 1.503 0 0 1 0-3.006M11.875.66v6.003M8.246 2.746H10M8.246 4.617H10"
    ></path>
  </svg>
);

export default FamilyTicketIcon;
